// tslint:disable
import { Injectable } from '@angular/core';

import { DwItem, DwItemDetail, DwQuery, DwOrmData } from '@devwareapps/devware-cap';
import * as EnterpriseMetaData from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/************************************************
   Generated with the Devware CAP CLI 4.4.44
   Code Gen Name   Surveys
   API Url         https://wappsdev.wachter.com/DevwareCapApi/

   Generated By    MSI/mlt
   Generate On     7/30/2024 1:41:08 PM
************************************************/

export enum SurveysMetaDataItemNames {
    EthosUser = 'Ethos_User',
    EthosUserDiff = 'Ethos_UserDiff',
    EthosUserSkill = 'Ethos_UserSkill',
    RoAvStarRatingNspTech = 'roAvStarRatingNspTech',
    RoEthosUser = 'roEthos_User',
    RoEthosUserOriginal = 'roEthos_UserOriginal',
    RoStarRatingNotificationTargets = 'roStarRatingNotificationTargets',
    StarRatingAvProjects = 'StarRatingAvProjects',
    StarRatingFieldExperience = 'StarRatingFieldExperience',
    StarRatingNotification = 'StarRatingNotification',
    StarRatingNotificationType = 'StarRatingNotificationType',
}

export enum SurveysMetaDataLookups {
    EmployeesByDeptIncTrainees = 2812,
    EthosUserBySupervisor = 1758,
    EthosUserBySupervisorPlusIndirect = 1773,
    EthosUserByUsersDepartment = 1582,
    ETHOSUSERNSPLBUOfficeActiveEmployees = 1696,
    ETHOSUSERWachterEmployeesActiveEmployees = 1464,
    EthosUserAllItems = 1416,
    EthosUserNSPUsers = 2981,
    EthosUserEmployeeGroups = 2858,
    EthosUserDiffAllItems = 1623,
    EthosUserSkillAllItems = 1413,
    FieldRatingOfficeAllItems = 1843,
    NSPInstallTechs = 2983,
    RoAvStarRatingNspTechAllItems = 2982,
    RoEthosUserActiveOnly = 2837,
    RoEthosUserAllActiveThenInactive = 2889,
    RoEthosUserAllItems = 1422,
    RoEthosUserOriginalAllItems = 1753,
    RoStarRatingNotificationTargetsAllItems = 1857,
    StarRatingAvProjectsAllItems = 2969,
    StarRatingNotificationAllItems = 1856,
    StarRatingNotificationTypeAllItems = 1855,
}

@Injectable({
    providedIn: 'root'
})
export class SurveysMetaDataService {

    EthosUser : EthosUserMetaData = new EthosUserMetaData();
    EthosUserDiff : EthosUserDiffMetaData = new EthosUserDiffMetaData();
    EthosUserSkill : EthosUserSkillMetaData = new EthosUserSkillMetaData();
    RoAvStarRatingNspTech : RoAvStarRatingNspTechMetaData = new RoAvStarRatingNspTechMetaData();
    RoEthosUser : RoEthosUserMetaData = new RoEthosUserMetaData();
    RoEthosUserOriginal : RoEthosUserOriginalMetaData = new RoEthosUserOriginalMetaData();
    RoStarRatingNotificationTargets : RoStarRatingNotificationTargetsMetaData = new RoStarRatingNotificationTargetsMetaData();
    StarRatingAvProjects : StarRatingAvProjectsMetaData = new StarRatingAvProjectsMetaData();
    StarRatingFieldExperience : StarRatingFieldExperienceMetaData = new StarRatingFieldExperienceMetaData();
    StarRatingNotification : StarRatingNotificationMetaData = new StarRatingNotificationMetaData();
    StarRatingNotificationType : StarRatingNotificationTypeMetaData = new StarRatingNotificationTypeMetaData();
}

// Generated Classes for MetaData service
export class EthosUserMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_User.';

    constructor() {
        this.ItemDetail.ItemId=2413;
        this.ItemDetail.ItemName='Ethos_User';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    EmployeeType : string = this.i + 'EmployeeType';
    StateProvinceId : string = this.i + 'StateProvinceId';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    CustomerId : string = this.i + 'CustomerId';
    SubcontractorId : string = this.i + 'SubcontractorId';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    IsVaxxed : string = this.i + 'isVaxxed';

    Relations = {
            /** Relation: Ethos User - Supervisor User - One */
            EthosUserBySupervisorUserId : {
                RelationName: 'Supervisor_User',
                FieldPrefix: 'SupervisorEthosUser',
                PropertyName: 'SupervisorEthosUser'
            },
            /** Relation: Ethos User Diff - Many */
            EthosUserDiffByEthosUserId : {
                RelationName: 'Ethos_User|Ethos_UserDiff|Ethos_UserId',
                FieldPrefix: 'EthosEthosUserDiff',
                PropertyName: 'EthosEthosUserDiff'
            },
            /** Relation: User Skill */
            EthosUserSkill : {
                RelationName: 'Ethos_User|Ethos_UserSkill|UserId',
                FieldPrefix: 'EthosUserSkill',
                PropertyName: 'EthosUserSkill'
            },
            /** Relation: Ro Ethos User */
            RoEthosUser : {
                RelationName: 'Ethos_User|roEthos_User|UserId',
                FieldPrefix: 'RoEthosUser',
                PropertyName: 'RoEthosUser'
            },
            /** Relation: Ro Ethos User - Supervisor - Many */
            RoEthosUserBySupervisorUserId : {
                RelationName: 'Ethos_User|roEthos_User|SupervisorUserId',
                FieldPrefix: 'SupervisorRoEthosUser',
                PropertyName: 'SupervisorRoEthosUser'
            },
            /** Relation: Star Rating Av Projects - Created By - Many */
            StarRatingAvProjectsByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|StarRatingAvProjects|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosStarRatingAvProjects',
                PropertyName: 'CreatedByEthosStarRatingAvProjects'
            },
            /** Relation: Star Rating Av Projects - Followed Up By - Many */
            StarRatingAvProjectsByFollowedUpByEthosUserId : {
                RelationName: 'Ethos_User|StarRatingAvProjects|FollowedUpByEthos_UserId',
                FieldPrefix: 'FollowedUpByEthosStarRatingAvProjects',
                PropertyName: 'FollowedUpByEthosStarRatingAvProjects'
            },
            /** Relation: Star Rating Av Projects - Modified By - Many */
            StarRatingAvProjectsByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|StarRatingAvProjects|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosStarRatingAvProjects',
                PropertyName: 'ModifiedByEthosStarRatingAvProjects'
            },
            /** Relation: Star Rating Av Projects - Project Manager - Many */
            StarRatingAvProjectsByProjectManagerEthosUserId : {
                RelationName: 'Ethos_User|StarRatingAvProjects|ProjectManagerEthos_UserId',
                FieldPrefix: 'ProjectManagerEthosStarRatingAvProjects',
                PropertyName: 'ProjectManagerEthosStarRatingAvProjects'
            },
            /** Relation: Star Rating Av Projects - Nsp Install Technician - Many */
            StarRatingAvProjectsByNspInstallTechnicianUserId : {
                RelationName: 'Ethos_User|StarRatingAvProjects|NspInstallTechnicianUserId',
                FieldPrefix: 'NspInstallTechnicianStarRatingAvProjects',
                PropertyName: 'NspInstallTechnicianStarRatingAvProjects'
            },
            /** Relation: Star Rating - Field Experience - Project Manager - Many */
            StarRatingFieldExperienceByProjectManagerEthosUserId : {
                RelationName: 'Ethos_User|StarRatingFieldExperience|ProjectManagerEthos_UserId',
                FieldPrefix: 'ProjectManagerEthosStarRatingFieldExperience',
                PropertyName: 'ProjectManagerEthosStarRatingFieldExperience'
            },
            /** Relation: Star Rating - Field Experience - Created By - Many */
            StarRatingFieldExperienceByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|StarRatingFieldExperience|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosStarRatingFieldExperience',
                PropertyName: 'CreatedByEthosStarRatingFieldExperience'
            },
            /** Relation: Star Rating - Field Experience - Modified By - Many */
            StarRatingFieldExperienceByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|StarRatingFieldExperience|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosStarRatingFieldExperience',
                PropertyName: 'ModifiedByEthosStarRatingFieldExperience'
            },
            /** Relation: Star Rating - Field Experience - Followed Up By - Many */
            StarRatingFieldExperienceByFollowedUpByEthosUserId : {
                RelationName: 'Ethos_User|StarRatingFieldExperience|FollowedUpByEthos_UserId',
                FieldPrefix: 'FollowedUpByEthosStarRatingFieldExperience',
                PropertyName: 'FollowedUpByEthosStarRatingFieldExperience'
            },
    };
}

export class EthosUserDiffMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_UserDiff.';

    constructor() {
        this.ItemDetail.ItemId=2572;
        this.ItemDetail.ItemName='Ethos_UserDiff';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EthosUserDiffId : string = this.i + 'Ethos_UserDiffId';
    EthosUserId : string = this.i + 'Ethos_UserId';
    FieldName : string = this.i + 'FieldName';
    OldValue : string = this.i + 'OldValue';
    NewValue : string = this.i + 'NewValue';
    ChangedDateTime : string = this.i + 'ChangedDateTime';

    Relations = {
            /** Relation: Ethos User - User */
            EthosUserByEthosUserId : {
                RelationName: 'Ethos_User|Ethos_UserDiff|Ethos_UserId',
                FieldPrefix: 'EthosEthosUser',
                PropertyName: 'EthosEthosUser'
            },
    };
}

export class EthosUserSkillMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_UserSkill.';

    constructor() {
        this.ItemDetail.ItemId=2410;
        this.ItemDetail.ItemName='Ethos_UserSkill';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserSkillId : string = this.i + 'UserSkillId';
    UserId : string = this.i + 'UserId';
    SkillCv : string = this.i + 'SkillCv';
    Meaning : string = this.i + 'Meaning';
    Display : string = this.i + 'Display';

    Relations = {
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_User|Ethos_UserSkill|UserId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
    };
}

export class RoAvStarRatingNspTechMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roAvStarRatingNspTech.';

    constructor() {
        this.ItemDetail.ItemId=3450;
        this.ItemDetail.ItemName='roAvStarRatingNspTech';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobId : string = this.i + 'JobId';
    TechUserId : string = this.i + 'TechUserId';

    Relations = {
    };
}

export class RoEthosUserMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEthos_User.';

    constructor() {
        this.ItemDetail.ItemId=2419;
        this.ItemDetail.ItemName='roEthos_User';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    TeamName : string = this.i + 'TeamName';
    TeamShortName : string = this.i + 'TeamShortName';
    TeamNickName : string = this.i + 'TeamNickName';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    NameLastFirst : string = this.i + 'NameLastFirst';
    NameLastPrefered : string = this.i + 'NameLastPrefered';
    NameLastFirstPrefered : string = this.i + 'NameLastFirstPrefered';
    NameFirstLast : string = this.i + 'NameFirstLast';
    NamePreferedLast : string = this.i + 'NamePreferedLast';
    NameFirstPreferedLast : string = this.i + 'NameFirstPreferedLast';
    NameFirstMiddleLast : string = this.i + 'NameFirstMiddleLast';
    NamePreferedMidInitialLast : string = this.i + 'NamePreferedMidInitialLast';
    NameLastFirstPreferedStatus : string = this.i + 'NameLastFirstPreferedStatus';
    EmployeeType : string = this.i + 'EmployeeType';
    StateProvinceId : string = this.i + 'StateProvinceId';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    NameLastFirstPreferedType : string = this.i + 'NameLastFirstPreferedType';
    IsActive : string = this.i + 'IsActive';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    BirthMonthDate : string = this.i + 'BirthMonthDate';
    TerritoryId : string = this.i + 'TerritoryId';
    TerritoryName : string = this.i + 'TerritoryName';
    Company : string = this.i + 'Company';
    LicenseCount : string = this.i + 'LicenseCount';
    AXId : string = this.i + 'AXId';
    YrsService : string = this.i + 'YrsService';
    StaffingAgencyName : string = this.i + 'StaffingAgencyName';

    Relations = {
            /** Relation: Ro Ethos User - Supervisor User - One */
            RoEthosUserBySupervisorUserId : {
                RelationName: 'roEthos_User|roEthos_User|SupervisorId',
                FieldPrefix: 'SupervisorRoEthosUser',
                PropertyName: 'SupervisorRoEthosUser'
            },
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_User|roEthos_User|UserId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
            /** Relation: Ethos User - Supervisor User */
            EthosUserBySupervisorUserId : {
                RelationName: 'Ethos_User|roEthos_User|SupervisorUserId',
                FieldPrefix: 'SupervisorEthosUser',
                PropertyName: 'SupervisorEthosUser'
            },
    };
}

export class RoEthosUserOriginalMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEthos_UserOriginal.';

    constructor() {
        this.ItemDetail.ItemId=2661;
        this.ItemDetail.ItemName='roEthos_UserOriginal';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    AXId : string = this.i + 'AXId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    EmployeeType : string = this.i + 'EmployeeType';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    BirthMonthDate : string = this.i + 'BirthMonthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsActive : string = this.i + 'IsActive';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceId : string = this.i + 'StateProvinceId';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    TerritoryId : string = this.i + 'TerritoryId';
    TerritoryName : string = this.i + 'TerritoryName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    TeamName : string = this.i + 'TeamName';
    TeamShortName : string = this.i + 'TeamShortName';
    TeamNickName : string = this.i + 'TeamNickName';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    Company : string = this.i + 'Company';
    LicenseCount : string = this.i + 'LicenseCount';
    NameLastFirst : string = this.i + 'NameLastFirst';
    NameLastPrefered : string = this.i + 'NameLastPrefered';
    NameLastFirstPrefered : string = this.i + 'NameLastFirstPrefered';
    NameFirstLast : string = this.i + 'NameFirstLast';
    NamePreferedLast : string = this.i + 'NamePreferedLast';
    NameFirstPreferedLast : string = this.i + 'NameFirstPreferedLast';
    NameFirstMiddleLast : string = this.i + 'NameFirstMiddleLast';
    NamePreferedMidInitialLast : string = this.i + 'NamePreferedMidInitialLast';
    NameLastFirstPreferedStatus : string = this.i + 'NameLastFirstPreferedStatus';
    NameLastFirstPreferedType : string = this.i + 'NameLastFirstPreferedType';

    Relations = {
    };
}

export class RoStarRatingNotificationTargetsMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roStarRatingNotificationTargets.';

    constructor() {
        this.ItemDetail.ItemId=2743;
        this.ItemDetail.ItemName='roStarRatingNotificationTargets';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    StarRatingFieldExperienceId : string = this.i + 'StarRatingFieldExperienceId';
    Email : string = this.i + 'Email';
    EmailType : string = this.i + 'EmailType';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    UserTypeCv : string = this.i + 'UserTypeCv';

    Relations = {
            /** Relation: Star Rating - Field Experience */
            StarRatingFieldExperience : {
                RelationName: 'Star Rating Notification Targets',
                FieldPrefix: 'StarRatingFieldExperience',
                PropertyName: 'StarRatingFieldExperience'
            },
    };
}

export class StarRatingAvProjectsMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'StarRatingAvProjects.';

    constructor() {
        this.ItemDetail.ItemId=3444;
        this.ItemDetail.ItemName='StarRatingAvProjects';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    StarRatingAvProjectsId : string = this.i + 'StarRatingAvProjectsId';
    EthosJobId : string = this.i + 'Ethos_JobId';
    ProjectManagerEthosUserId : string = this.i + 'ProjectManagerEthos_UserId';
    NspPmScore : string = this.i + 'NspPmScore';
    NspInstallTechScore : string = this.i + 'NspInstallTechScore';
    WtsPmScore : string = this.i + 'WtsPmScore';
    WtsEngineerScore : string = this.i + 'WtsEngineerScore';
    OverallScore : string = this.i + 'OverallScore';
    AdditionalComments : string = this.i + 'AdditionalComments';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    FollowUpRequested : string = this.i + 'FollowUpRequested';
    FollowedUpOnDateTime : string = this.i + 'FollowedUpOnDateTime';
    FollowedUpByEthosUserId : string = this.i + 'FollowedUpByEthos_UserId';
    HasBeenReviewed : string = this.i + 'HasBeenReviewed';
    NspInstallTechnicianUserId : string = this.i + 'NspInstallTechnicianUserId';

    Relations = {
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|StarRatingAvProjects|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Followed Up By Ethos User */
            EthosUserByFollowedUpByEthosUserId : {
                RelationName: 'Ethos_User|StarRatingAvProjects|FollowedUpByEthos_UserId',
                FieldPrefix: 'FollowedUpByEthosEthosUser',
                PropertyName: 'FollowedUpByEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|StarRatingAvProjects|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Project Manager Ethos User */
            EthosUserByProjectManagerEthosUserId : {
                RelationName: 'Ethos_User|StarRatingAvProjects|ProjectManagerEthos_UserId',
                FieldPrefix: 'ProjectManagerEthosEthosUser',
                PropertyName: 'ProjectManagerEthosEthosUser'
            },
            /** Relation: Ethos User - Nsp Install Technician User */
            EthosUserByNspInstallTechnicianUserId : {
                RelationName: 'Ethos_User|StarRatingAvProjects|NspInstallTechnicianUserId',
                FieldPrefix: 'NspInstallTechnicianEthosUser',
                PropertyName: 'NspInstallTechnicianEthosUser'
            },
    };
}

export class StarRatingFieldExperienceMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'StarRatingFieldExperience.';

    constructor() {
        this.ItemDetail.ItemId=2736;
        this.ItemDetail.ItemName='StarRatingFieldExperience';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    StarRatingFieldExperienceId : string = this.i + 'StarRatingFieldExperienceId';
    ProjectManagerEthosUserId : string = this.i + 'ProjectManagerEthos_UserId';
    AdditionalComments : string = this.i + 'AdditionalComments';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    EthosJobId : string = this.i + 'Ethos_JobId';
    FollowUpRequested : string = this.i + 'FollowUpRequested';
    OverallScore : string = this.i + 'OverallScore';
    SchedulingScore : string = this.i + 'SchedulingScore';
    ResponsivenessScore : string = this.i + 'ResponsivenessScore';
    SupportScore : string = this.i + 'SupportScore';
    HasBeenReviewed : string = this.i + 'HasBeenReviewed';
    FollowedUpOnDateTime : string = this.i + 'FollowedUpOnDateTime';
    FollowedUpByEthosUserId : string = this.i + 'FollowedUpByEthos_UserId';
    NoteParentId : string = this.i + 'NoteParentId';

    Relations = {
            /** Relation: Ethos User - PM Ethos ID */
            EthosUserByProjectManagerEthosUserId : {
                RelationName: 'Ethos_User|StarRatingFieldExperience|ProjectManagerEthos_UserId',
                FieldPrefix: 'ProjectManagerEthosEthosUser',
                PropertyName: 'ProjectManagerEthosEthosUser'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|StarRatingFieldExperience|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|StarRatingFieldExperience|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Followed Up By Ethos User */
            EthosUserByFollowedUpByEthosUserId : {
                RelationName: 'Ethos_User|StarRatingFieldExperience|FollowedUpByEthos_UserId',
                FieldPrefix: 'FollowedUpByEthosEthosUser',
                PropertyName: 'FollowedUpByEthosEthosUser'
            },
            /** Relation: Ro Star Rating Notification Targets */
            RoStarRatingNotificationTargets : {
                RelationName: 'Star Rating Notification Targets',
                FieldPrefix: 'RoStarRatingNotificationTargets',
                PropertyName: 'RoStarRatingNotificationTargets'
            },
    };
}

export class StarRatingNotificationMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'StarRatingNotification.';

    constructor() {
        this.ItemDetail.ItemId=2742;
        this.ItemDetail.ItemName='StarRatingNotification';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    StarRatingNotificationId : string = this.i + 'StarRatingNotificationId';
    StarRatingNotificationTypeId : string = this.i + 'StarRatingNotificationTypeId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    UserTypeCv : string = this.i + 'UserTypeCv';
    Email : string = this.i + 'Email';

    Relations = {
            /** Relation: Star Rating Notification Type - Type */
            StarRatingNotificationTypeByStarRatingNotificationTypeId : {
                RelationName: 'StarRatingNotificationType|StarRatingNotification|StarRatingNotificationTypeId',
                FieldPrefix: 'StarRatingNotificationStarRatingNotificationType',
                PropertyName: 'StarRatingNotificationStarRatingNotificationType'
            },
    };
}

export class StarRatingNotificationTypeMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'StarRatingNotificationType.';

    constructor() {
        this.ItemDetail.ItemId=2741;
        this.ItemDetail.ItemName='StarRatingNotificationType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TypeId : string = this.i + 'TypeId';
    Display : string = this.i + 'Display';
    DisplayShortName : string = this.i + 'DisplayShortName';

    Relations = {
            /** Relation: Star Rating Notification - Many */
            StarRatingNotificationByStarRatingNotificationTypeId : {
                RelationName: 'StarRatingNotificationType|StarRatingNotification|StarRatingNotificationTypeId',
                FieldPrefix: 'StarRatingNotificationStarRatingNotification',
                PropertyName: 'StarRatingNotificationStarRatingNotification'
            },
    };
}

export class SurveysMetaData {

    static EthosUser : EthosUserMetaData = new EthosUserMetaData();
    static EthosUserDiff : EthosUserDiffMetaData = new EthosUserDiffMetaData();
    static EthosUserSkill : EthosUserSkillMetaData = new EthosUserSkillMetaData();
    static RoAvStarRatingNspTech : RoAvStarRatingNspTechMetaData = new RoAvStarRatingNspTechMetaData();
    static RoEthosUser : RoEthosUserMetaData = new RoEthosUserMetaData();
    static RoEthosUserOriginal : RoEthosUserOriginalMetaData = new RoEthosUserOriginalMetaData();
    static RoStarRatingNotificationTargets : RoStarRatingNotificationTargetsMetaData = new RoStarRatingNotificationTargetsMetaData();
    static StarRatingAvProjects : StarRatingAvProjectsMetaData = new StarRatingAvProjectsMetaData();
    static StarRatingFieldExperience : StarRatingFieldExperienceMetaData = new StarRatingFieldExperienceMetaData();
    static StarRatingNotification : StarRatingNotificationMetaData = new StarRatingNotificationMetaData();
    static StarRatingNotificationType : StarRatingNotificationTypeMetaData = new StarRatingNotificationTypeMetaData();
}
// Generated Entity Interfaces
export interface EthosUserEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceShortName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    RowInsertDateTime?: string;
    EmployeeType?: string;
    StateProvinceId?: number;
    PictureAttachmentFileKey?: string;
    CustomerId?: number;
    SubcontractorId?: number;
    SpecialInstructions?: string;
    isVaxxed?: boolean;

    // Display Attributes
    UserIdDisplay?: string;
    WachterJobTitleIdDisplay?: string;
    UserTypeCvDisplay?: string;
    StaffingAgencyIdDisplay?: string;
    ResourceGroupCvDisplay?: string;
    WachterTeamIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    SupervisorUserIdDisplay?: string;
    UserStatusWsDisplay?: string;
    StateProvinceIdDisplay?: string;
    CustomerIdDisplay?: string;

    // Relations
    SupervisorEthosUser? : EthosUserEntity;
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity;
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity[];
    EthosEthosUserDiff? : EthosUserDiffEntity[];
    EthosUserSkill? : EthosUserSkillEntity[];
    RoEthosUser? : RoEthosUserEntity;
    SupervisorRoEthosUser? : RoEthosUserEntity[];
    CreatedByEthosStarRatingAvProjects? : StarRatingAvProjectsEntity[];
    FollowedUpByEthosStarRatingAvProjects? : StarRatingAvProjectsEntity[];
    ModifiedByEthosStarRatingAvProjects? : StarRatingAvProjectsEntity[];
    ProjectManagerEthosStarRatingAvProjects? : StarRatingAvProjectsEntity[];
    NspInstallTechnicianStarRatingAvProjects? : StarRatingAvProjectsEntity[];
    ProjectManagerEthosStarRatingFieldExperience? : StarRatingFieldExperienceEntity[];
    CreatedByEthosStarRatingFieldExperience? : StarRatingFieldExperienceEntity[];
    ModifiedByEthosStarRatingFieldExperience? : StarRatingFieldExperienceEntity[];
    FollowedUpByEthosStarRatingFieldExperience? : StarRatingFieldExperienceEntity[];
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity[];
}

export interface EthosUserDiffEntity extends DwOrmData {
    // Attributes
    Ethos_UserDiffId?: number;
    Ethos_UserId?: number;
    FieldName?: string;
    OldValue?: string;
    NewValue?: string;
    ChangedDateTime?: string;

    // Display Attributes
    Ethos_UserIdDisplay?: string;

    // Relations
    EthosEthosUser? : EthosUserEntity;
}

export interface EthosUserSkillEntity extends DwOrmData {
    // Attributes
    UserSkillId?: number;
    UserId?: number;
    SkillCv?: number;
    Meaning?: string;
    Display?: string;

    // Display Attributes
    UserIdDisplay?: string;
    SkillCvDisplay?: string;

    // Relations
    EthosUser? : EthosUserEntity;
}

export interface RoAvStarRatingNspTechEntity extends DwOrmData {
    // Attributes
    JobId?: number;
    TechUserId?: number;

    // Display Attributes
    TechUserIdDisplay?: string;

    // Relations
}

export interface RoEthosUserEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceShortName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    RowInsertDateTime?: string;
    TeamName?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    NameLastFirst?: string;
    NameLastPrefered?: string;
    NameLastFirstPrefered?: string;
    NameFirstLast?: string;
    NamePreferedLast?: string;
    NameFirstPreferedLast?: string;
    NameFirstMiddleLast?: string;
    NamePreferedMidInitialLast?: string;
    NameLastFirstPreferedStatus?: string;
    EmployeeType?: string;
    StateProvinceId?: number;
    PictureAttachmentFileKey?: string;
    NameLastFirstPreferedType?: string;
    IsActive?: number;
    SpecialInstructions?: string;
    BirthMonthDate?: string;
    TerritoryId?: number;
    TerritoryName?: string;
    Company?: string;
    LicenseCount?: number;
    AXId?: string;
    YrsService?: number;
    StaffingAgencyName?: string;

    // Display Attributes
    UserIdDisplay?: string;
    WachterJobTitleIdDisplay?: string;
    UserTypeCvDisplay?: string;
    StaffingAgencyIdDisplay?: string;
    ResourceGroupCvDisplay?: string;
    WachterTeamIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    SupervisorUserIdDisplay?: string;
    UserStatusWsDisplay?: string;
    StateProvinceIdDisplay?: string;
    TerritoryIdDisplay?: string;

    // Relations
    SupervisorRoEthosUser? : RoEthosUserEntity;
    EthosUser? : EthosUserEntity;
    SupervisorEthosUser? : EthosUserEntity;
    // Duplicate property excluded
    // SupervisorRoEthosUser : RoEthosUserEntity[];
}

export interface RoEthosUserOriginalEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    AXId?: string;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    EmployeeType?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    BirthMonthDate?: string;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsActive?: number;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentFileKey?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceId?: number;
    StateProvinceShortName?: string;
    TerritoryId?: number;
    TerritoryName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    SpecialInstructions?: string;
    RowInsertDateTime?: string;
    TeamName?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    Company?: number;
    LicenseCount?: number;
    NameLastFirst?: string;
    NameLastPrefered?: string;
    NameLastFirstPrefered?: string;
    NameFirstLast?: string;
    NamePreferedLast?: string;
    NameFirstPreferedLast?: string;
    NameFirstMiddleLast?: string;
    NamePreferedMidInitialLast?: string;
    NameLastFirstPreferedStatus?: string;
    NameLastFirstPreferedType?: string;


    // Relations
}

export interface RoStarRatingNotificationTargetsEntity extends DwOrmData {
    // Attributes
    StarRatingFieldExperienceId?: number;
    Email?: string;
    EmailType?: string;
    WachterDepartmentId?: number;
    UserTypeCv?: number;


    // Relations
    StarRatingFieldExperience? : StarRatingFieldExperienceEntity;
}

export interface StarRatingAvProjectsEntity extends DwOrmData {
    // Attributes
    StarRatingAvProjectsId?: number;
    Ethos_JobId?: number;
    ProjectManagerEthos_UserId?: number;
    NspPmScore?: number;
    NspInstallTechScore?: number;
    WtsPmScore?: number;
    WtsEngineerScore?: number;
    OverallScore?: number;
    AdditionalComments?: string;
    IsDeleted?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    FollowUpRequested?: boolean;
    FollowedUpOnDateTime?: string;
    FollowedUpByEthos_UserId?: number;
    HasBeenReviewed?: boolean;
    NspInstallTechnicianUserId?: number;

    // Display Attributes
    Ethos_JobIdDisplay?: string;
    ProjectManagerEthos_UserIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    FollowedUpByEthos_UserIdDisplay?: string;
    NspInstallTechnicianUserIdDisplay?: string;

    // Relations
    CreatedByEthosEthosUser? : EthosUserEntity;
    FollowedUpByEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    ProjectManagerEthosEthosUser? : EthosUserEntity;
    NspInstallTechnicianEthosUser? : EthosUserEntity;
}

export interface StarRatingFieldExperienceEntity extends DwOrmData {
    // Attributes
    StarRatingFieldExperienceId?: number;
    ProjectManagerEthos_UserId?: number;
    AdditionalComments?: string;
    CreatedByEthos_UserId?: number;
    ModifiedByEthos_UserId?: number;
    IsDeleted?: boolean;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    Ethos_JobId?: number;
    FollowUpRequested?: boolean;
    OverallScore?: number;
    SchedulingScore?: number;
    ResponsivenessScore?: number;
    SupportScore?: number;
    HasBeenReviewed?: boolean;
    FollowedUpOnDateTime?: string;
    FollowedUpByEthos_UserId?: number;
    NoteParentId?: number;

    // Display Attributes
    ProjectManagerEthos_UserIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    Ethos_JobIdDisplay?: string;
    FollowedUpByEthos_UserIdDisplay?: string;
    NoteParentIdDisplay?: string;

    // Relations
    ProjectManagerEthosEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    FollowedUpByEthosEthosUser? : EthosUserEntity;
    RoStarRatingNotificationTargets? : RoStarRatingNotificationTargetsEntity[];
}

export interface StarRatingNotificationEntity extends DwOrmData {
    // Attributes
    StarRatingNotificationId?: number;
    StarRatingNotificationTypeId?: number;
    WachterDepartmentId?: number;
    UserTypeCv?: number;
    Email?: string;

    // Display Attributes
    StarRatingNotificationTypeIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    UserTypeCvDisplay?: string;

    // Relations
    StarRatingNotificationStarRatingNotificationType? : StarRatingNotificationTypeEntity;
}

export interface StarRatingNotificationTypeEntity extends DwOrmData {
    // Attributes
    TypeId?: number;
    Display?: string;
    DisplayShortName?: string;


    // Relations
    StarRatingNotificationStarRatingNotification? : StarRatingNotificationEntity[];
}



